function Loading() {
    return(
        <div className="w-full h-full flex justify-center items-center">
            <img src="/loading.png" alt="loading" width={30} height={30} className="animate-spin" />
        </div>
    )
}

export default Loading